export default hashid => (
  window.open(`${process.env.API_LOCATION}/product/barcode/${hashid}/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/packageOrderProduct/show.js